import { useEffect, useMemo } from 'react'
import flattenFilters from '../utils/flattenFilters'

interface useAutoSelectFilterPageProps {
  isCreate: boolean
  selectedFilter: any
  filters: any[]
  goToPage: (page: number) => void
}

const useAutoSelectFilterPage = ({
  isCreate,
  selectedFilter,
  filters,
  goToPage,
}: useAutoSelectFilterPageProps) => {

  const flattenFilterTreeAndGetIds = (filter: any): any[] => {
    const result = [filter.id]
    if (filter.filters && filter.filters.length > 0) {
      for (const child of filter.filters) {
        result.push(...flattenFilterTreeAndGetIds(child))
      }
    }
    return result
  }

  useEffect(() => {
    if (!isCreate){
      return
    }

    if(selectedFilter === null){
      goToPage(1)
      return
    }

    const findParentIndex = (filters: any[]): number => {
      for (let i = 0; i < filters.length; i++) {
        const filter = filters[i]
        if (filter.id === selectedFilter.id){
          return i
        }
        if (Array.isArray(filter.filters)) {
          const flat = flattenFilters(filter.filters)
          if (flat.some(f => f.id === selectedFilter.id)){
            return i
          }
        }
      }
      return -1
    }

    const index = findParentIndex(filters)
    if (index !== -1){
      goToPage(index + 1)
    }
  }, [selectedFilter?.id]) 

  const selectedFilterAndChildrenIdsFlat = useMemo(() => {
    if (!selectedFilter){
      return []
    }
    return flattenFilterTreeAndGetIds(selectedFilter)
  }, [selectedFilter])

  return { selectedFilterAndChildrenIdsFlat }
}

export default useAutoSelectFilterPage